import { render } from "./CompanyForm.vue?vue&type=template&id=02344253"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Company/CompanyForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02344253"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02344253', __exports__)) {
    api.reload('02344253', __exports__)
  }
  
  module.hot.accept("./CompanyForm.vue?vue&type=template&id=02344253", () => {
    api.rerender('02344253', render)
  })

}


export default __exports__